<template>
	<ProjectRoleSelectorDisplay
		:role.sync="localRole"
		:disabled="readonly || !hasPermissionToChangeUsers"
		@updateRole="updateProjectMemberRole"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';

import ProjectRoleSelectorDisplay from './ProjectRoleSelectorDisplay.vue';
import { updateProjectMemberRole } from '@/store/modules/projects/actions';
import { projectHasPermission } from '@/store/modules/projects/getters';
export default {
	name: 'ProjectRoleSelector',
	components: { ProjectRoleSelectorDisplay },
	props: {
		projectId: { type: Number },
		role: { type: String },
		user: { type: Object },
		group: { type: Object },
		readonly: { type: Boolean },
	},
	methods: {
		...mapActions([updateProjectMemberRole.fullPath]),
		async updateProjectMemberRole(role) {
			const emails = this.user ? [this.user.email] : [];
			const groups = this.group ? [this.group.id] : [];
			await this[updateProjectMemberRole.fullPath]({ projectId: this.projectId, emails, groups, role });
		},
	},
	computed: {
		...mapGetters([projectHasPermission.fullPath]),
		hasPermissionToChangeUsers() {
			return this[projectHasPermission.fullPath](this.projectId, ProjectPermissions.ChangeProjectUsers);
		},
	},
	data() {
		return {
			localRole: this.role,
		};
	},
	watch: {
		localRole(newRole) {
			this.updateProjectMemberRole(newRole);
		},
	},
};
</script>

<style scoped lang="scss">
.text {
	padding-top: 4px;
	font-size: 14px;
}
.subtext {
	margin-top: -4px;
	padding-bottom: 4px;
	font-size: 11px;
	color: #9e9e9e;
}
.readonly-description {
	font-size: 10px;
}
</style>
